import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { LOADING_ANIMATION_BASE_CLASSNAME } from './Constants';
import { createLoadingAnimation } from './LoadingAnimation';
createComponents(".".concat(LOADING_ANIMATION_BASE_CLASSNAME), createLoadingAnimation, NO_PATTERN_BUSINESS_LOGIC);
